import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const Success = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paymentType = queryParams.get('type');
  const isACH = paymentType === 'ach';
  const isUpdate = paymentType === 'update';

  useEffect(() => {
    window.scrollTo(0, 0);
    // Set body background to black
    document.body.style.backgroundColor = '#000000';
    document.documentElement.style.backgroundColor = '#000000';
    
    // Cleanup: restore default background when component unmounts
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, []);

  return (
    <div className="success-page">
      <div className="success-icon-container">
        <div className="success-icon">
          <FontAwesomeIcon icon={faCheckCircle} className="checkmark" />
        </div>
      </div>

      <h1 className="success-heading">
        {isACH ? 'Monthly Payment Setup Successful!' : 
          isUpdate ? 'Subscription Details Updated!' : 'Payment Successful!'}
      </h1>

      <p className="success-message">
        {isACH ? 
          'Your automatic monthly payments have been set up. You will receive a confirmation email shortly.' :
          isUpdate ?
          'Your subscription details have been successfully updated.' :
          'Thank you for choosing Off Grid Developments. Your payment has been processed successfully and you will receive a confirmation email shortly.'}
      </p>

      {isACH && (
        <div className="info-card">
          <p>
            You can manage or cancel your automatic payments at any time through the link in your confirmation email.
          </p>
        </div>
      )}

      <Link to='/' className="home-button">
        Go back to Home
      </Link>
    </div>
  );
};

export default Success;
